import numeral from "numeral";

import PdfLine from "../../../pdf/component/pdf.c.line";
import { cn, getPathURL } from "../../../../utils/useFunctions";
import {
  options_education_rank,
  options_under_education,
} from "../../../education/functions/options";
import { PdfCardGray, PdfCardWhite } from "../../../pdf/component/pdf.c.card";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
} from "../../../pdf/styles/pdf.style";

function FuturePlanDetail({
  datalist = [],
  isChildrenEducation = false,
  ischileFuture = false,
}) {
  const currentEdu = (currentEducation) =>
    options_education_rank?.find((item) => item?.value === currentEducation)
      ?.label;
  const targetEdu = (targetEducation) =>
    options_education_rank?.find((item) => item?.value === targetEducation)
      ?.label;
  const underEdu = (underEducatiion) =>
    options_under_education?.find((item) => item?.value === underEducatiion)
      ?.label;

  return (
    <div>
      {!isChildrenEducation &&
        datalist?.map((item, index) => {

          return (
            <PdfCardWhite
              key={index}
              className={cn("flex flex-col space-y-2 px-3")}
            >
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-left text-base")}
              >
                {item?.title}
              </div>
              <PdfLine />
              <div className="flex items-center space-x-2">
                <div>
                  <img src={`/images/${item.icon}`} width={20} height={20} />
                </div>
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                  {item?.label}
                </div>
              </div>
              <PdfCardGray className={cn("px-2")}>
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                    {"คาดการณ์ไว้อีก"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2 text-base"
                    )}
                  >
                    {`${
                      [
                        "car",
                        "children",
                        "travel",
                        "collection",
                        "ETCExpense",
                      ].includes(item?.type)
                        ? item?.year
                        : item?.interest_year
                    } ปี`}
                  </div>
                </div>
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                    {ischileFuture ? "ค่าใช้จ่าย" : "เงินดาวน์"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2 text-base"
                    )}
                  >
                    {`${numeral(item?.down).format("0,0")} บาท`}
                  </div>
                </div>
                {["car"].includes(item?.type) && (
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {`ผลตอบแทน (ต่อปี)`}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${numeral(item?.invest_down_interest).format("0,0")} %`}
                    </div>
                  </div>
                )}
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                    {"ออมเงิน/ลงทุน เพื่อเงินดาวน์รถยนต์ ได้ดอกเบี้ย (ต่อปี)"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2 text-base"
                    )}
                  >
                    {`${numeral(item?.sum_invest_five).format("0,0")} บาท`}
                  </div>
                </div>
                <div className="flex justify-between space-y-1">
                  {item?.type === "home" && (
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"มูลค่าบ้าน (บาท)"}
                    </div>
                  )}
                  {item?.type === "car" && (
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"มูลค่ารถ (บาท)"}
                    </div>
                  )}
                  {(item?.type === "home" || item?.type === "car") && (
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${numeral(item?.value).format("0,0")} บาท`}
                    </div>
                  )}
                </div>
                <div className="flex justify-between space-y-1">
                  {item?.type === "home" && (
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"ดอกเบี้ยบ้าน (บาท)"}
                    </div>
                  )}
                  {item?.type === "car" && (
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"ต้องชำระงวดละ (บาท)"}
                    </div>
                  )}
                  {(item?.type === "home" || item?.type === "car") && (
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${numeral(item?.pay_per_year).format("0,0")} บาท`}
                    </div>
                  )}
                </div>
                {(item?.type === "home" || item?.type === "car") && (
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"ระยะเวลาที่ต้องการผ่อน"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${numeral(item?.period_year).format("0,0")} ปี`}
                    </div>
                  </div>
                )}
                {item?.type === "children" && (
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"เป้าหมายการศึกษา"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${
                        options_under_education?.find(
                          (item2) => item2?.value === item?.education_under
                        )?.label
                      } `}
                    </div>
                  </div>
                )}
              </PdfCardGray>
            </PdfCardWhite>
          );
        })}
      {isChildrenEducation &&
        datalist?.map((item, index) => {

          return (
            <PdfCardWhite
              key={index}
              className={cn("flex flex-col space-y-2 px-3")}
            >
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-left text-base")}
              >
                {`บุตรคนที่  ${index + 1}`}
              </div>
              <PdfLine />
              <PdfCardGray className={cn(" flex px-2")}>
                <div className="flex items-center space-x-2">
                  <div>
                    <img
                      src={item?.img ? getPathURL(item?.img) : `/images/user_circle.png`}
                      width={150}
                      height={150}
                    />
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                    {item?.label}
                  </div>
                </div>
                <div className="px-2 w-full">
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"ชื่อ"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${item?.name}`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"ปีเกิด"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {/* {`${numeral(item?.year).format("0,0")}`} */}
                      {`${item?.year}`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"อายุ"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${numeral(item?.age).format("0,0")}`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"การศึกษาปัจจุบัน"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${currentEdu(item?.current_education)}`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"เป้าหมายการศึกษา"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${targetEdu(item?.target_education)}`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                      {"สังกัดการศึกษา"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2 text-base"
                      )}
                    >
                      {`${underEdu(item?.under_education)}`}
                    </div>
                  </div>
                </div>
              </PdfCardGray>
            </PdfCardWhite>
          );
        })}
    </div>
  );
}

export default FuturePlanDetail;
